import React, { FC } from "react";

import "./style.scss";

const NotFound: FC = () => {
  return <div className="not-found-page">Page not found.</div>;
};

export default NotFound;
